/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DigaEnum = {
    InvirtoAnxiety: 'INVIRTO_ANXIETY',
    InvirtoAnxietyAftercare: 'INVIRTO_ANXIETY_AFTERCARE',
    InvirtoDepression: 'INVIRTO_DEPRESSION'
} as const;
export type DigaEnum = typeof DigaEnum[keyof typeof DigaEnum];

